import { ConversationTagSource } from "@redotech/redo-common-model/conversation-tags/conversation-tag-source";
import { PillTheme } from "@redotech/redo-storefront-common/pill-theme";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getConversationTagsById = {
  name: "getConversationTagsById" as const,
  input: z.object({ tagIds: z.array(zExt.objectId()) }),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      teamId: zExt.objectId(),
      name: z.string(),
      pillTheme: createEnum(PillTheme),
      source: createEnum(ConversationTagSource),
      tagGroupId: zExt.objectId().optional(),
    }),
  ),
};
